import internalApiClient from '../api/internalApiClient';
import track from './mixpanel';

export async function administrateAgreement(
    userId,
    adminAgreementNumber,
    isBarred,
    isMismatched2FA,
    agreementNumber,
    onBarredAccount: () => void,
    onMismatched2FAAccount: () => void
) {
    track('admin-central', 'administrate-company.clicked');

    if (isBarred) {
        return onBarredAccount();
    }

    if (isMismatched2FA) {
        return onMismatched2FAAccount();
    }

    const response = await internalApiClient.post('/agreementselector/switch', {
        agreementNumber,
        adminAgreementNumber,
        userId,
    });

    if (response?.data.redirectUrl) {
        window.location.href = response.data.redirectUrl;
    } else {
        window.location.href = window.location.origin;
    }
}
